module.exports = __webpack_public_path__ + "static/media/star-purple-filled.b9bf60f4.svg";